// src/pages/admin/mixedCompanyAssignJobs/styles.js — shared Tailwind class strings used
// across MixedCompanyAssignJobs and its extracted select components.
export const inputClass =
  "w-full rounded-xl border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-emerald-400 focus:ring-4 focus:ring-emerald-100";

export const labelClass =
  "text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500";

export const fieldWrapClass = "flex flex-col gap-1.5";
